import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "react-bootstrap-multiselect/css/bootstrap-multiselect.css";
import "react-dropdown-tree-select/dist/styles.css";
import { toast } from "react-toastify";
import PageLoader from "../components/PageLoader";
import StatContainer from "../components/StatContainer";
import { Constants } from "../libs/Constants";
import { getList } from "../libs/dbFunctions";
import { numberWithCommas, roundToDigit } from "../libs/utils";
import DoughnutChart from "./Charts/DoughnutChart";
import PeriodFilter from "./PeriodFilter";
//[{label:"", data: 1, color:""}]
const initDoughnutData = [
  { label: "Non-participating", data: 0, color: "#4E729B" },
  { label: "Participating", data: 0, color: "#423E60" },
];

const PeopleWidget = (props) => {
  const [people, setPeople] = useState({
    employee: {
      total: 0,
      part: 0,
      non_part: 0,
      departments: [],
    },
  });
  const [peopleContributionSummary, setPeopleContributionSummary] = useState({
    new_withdraw: 0,
    new_participants: 0,
    new_terminate: 0,
  });
  const [doughnutData, setDoughnutData] = useState(initDoughnutData);

  const [loading, setLoading] = useState(false);
  const [displayPeriod, setDisplayPeriod] = useState(null);

  useEffect(() => {
    if (people) loadChartData();
  }, [people]);

  function loadChartData() {
    //load doughnut data
    let chartData = [...doughnutData];
    chartData[0].data = people?.employee?.non_part;
    chartData[1].data = people?.employee?.part;
    setDoughnutData(chartData);
  }

  async function loadPeopleContributionSummaryDetails(period) {
    setLoading(true);
    try {
      let params = {
        summaryType: Constants.SUMMARY_TYPE.PEOPLE_CONTRIBUTIONS,
        startdate: period.periodStartdate,
        enddate: period.periodEnddate,
      };
      let peopleDetails = await getList(
        Constants.dbTypes.SUMMARY,
        props.activeCompany,
        params
      );

      if (peopleDetails) {
        setPeopleContributionSummary(peopleDetails);
      }
    } catch (e) {
      toast.error(e);
    }
    setLoading(false);
  }

  async function loadPeopleDetails() {
    setLoading(true);
    try {
      let params = {
        summaryType: Constants.SUMMARY_TYPE.PEOPLE,
      };
      let peopleDetails = await getList(
        Constants.dbTypes.SUMMARY,
        props.activeCompany,
        params
      );

      if (peopleDetails) {
        // Do some percent processing
        peopleDetails.participant_percent = 0;
        peopleDetails.non_participant_percent = 0;
        if (peopleDetails?.employee?.total) {
          if (peopleDetails?.employee?.non_part) {
            peopleDetails.non_participant_percent = roundToDigit(
              (peopleDetails?.employee?.non_part /
                peopleDetails?.employee?.total) *
                100,
              2
            );
          }
          if (peopleDetails?.employee?.part) {
            peopleDetails.participant_percent = roundToDigit(
              (peopleDetails?.employee?.part / peopleDetails?.employee?.total) *
                100,
              2
            );
          }
        }
        setPeople(peopleDetails);
      }
    } catch (e) {
      toast.error(e);
    }
    setLoading(false);
  }

  useEffect(() => {
    async function load() {
      loadPeopleDetails();
    }
    load();
  }, []);

  useEffect(() => {
    async function load() {
      if (displayPeriod) {
        loadPeopleContributionSummaryDetails(displayPeriod);
      }
    }
    load();
  }, [displayPeriod]);
  let gridData = [
    {
      title: "New Withdrawals",
      value: peopleContributionSummary?.new_withdraw,
    },
    {
      title: "New Participants",
      value: peopleContributionSummary?.new_participants,
    },
    {
      title: "New Terminations",
      value: peopleContributionSummary?.new_terminate,
    },
  ];
  // This function is used to display 2 column number grid
  function renderNumberGrid(arrayOfData, title) {
    return (
      <div className="pic-chart-box">
        {title && <h5 className="fw-bold">{title}</h5>}
        {arrayOfData.map((data, index) => {
          return (
            <p className={data.classes} key={index}>
              {data.title}:{" "}
              <span className={`font-h2 ${data?.classes}`}>
                {data.value ? data.value : "None"}
              </span>
            </p>
          );
        })}
      </div>
    );
  }

  function renderPeriodDropdown() {
    return (
      <PeriodFilter
        timezone={props.activeCompany.timezone}
        handlePeriodSelect={setDisplayPeriod}
        periods={props.periods}
      ></PeriodFilter>
    );
  }
  return (
    <StatContainer title="People">
      <PageLoader isActive={loading} individual={true}>
        <Row className="mb-3">
          <Col>{renderPeriodDropdown()}</Col>
        </Row>
        <Row className="n-boxde">
          <Col sm={12} md={6}>
            {renderNumberGrid(gridData, "Employee Info")}
          </Col>
          <Col sm={12} md={6}>
            <div className="pic-chart-box">
              <Row>
                <Col>
                  <h5 className="fw-bold">Employee Count</h5>

                  <p>
                    Total:
                    <span className={`font-h2 `}>
                      {numberWithCommas(people?.employee?.total || 0)}
                    </span>
                  </p>

                  <div className="d-flex graph-view align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div
                        className="dot"
                        style={{ background: "#4E729B" }}
                      ></div>
                      <div>Non Participants:</div>
                    </div>
                    <span className={`font-h2 value`}>
                      {numberWithCommas(people?.employee?.non_part || 0)}
                      {" /"} {people?.non_participant_percent}
                      {"%"}
                    </span>
                  </div>

                  <div className="d-flex graph-view align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div
                        className="dot"
                        style={{ background: "#423E60" }}
                      ></div>
                      <div>Participating:</div>
                    </div>
                    <span className={`font-h2 value`}>
                      {numberWithCommas(people?.employee?.part) || 0}
                      {" /"} {people?.participant_percent}
                      {"%"}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  {people?.employee?.total ? (
                    <div>
                      <DoughnutChart data={doughnutData} />
                    </div>
                  ) : null}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </PageLoader>
    </StatContainer>
  );
};

export default PeopleWidget;
